<template>
  <div class="navigation-section">
    <div class="title-container">
      <span class="title">Navigation</span>
      <InfoIcon :info-data="infoDetails['wr_navigation']" />
      <v-spacer />
      <span class="mr-2 float-right">
        <EditExtraVoyageSettings />
      </span>
    </div>

    <div class="content-container">
      <div class="column-container">
        <ThemedColumnText
          top-text="Land proximity"
          :bottom-text="landProximityText"
        />
        <ThemedColumnText
          top-text="Traffic Separation Schemas"
          :bottom-text="binaryText(tss)"
        />

        <ThemedColumnText
          top-text="Emission Control Areas"
          :bottom-text="binaryText(eca)"
        />
        <ThemedColumnText
          top-text="Avoid piracy zones"
          :bottom-text="binaryText(avoidPiracy)"
        />
        <ThemedColumnText
          top-text="Avoid tropical storms"
          :bottom-text="binaryText(avoidTropicalStorms)"
        />
      </div>
      <div class="column-container">
        <ThemedColumnText
          top-text="Suez"
          :bottom-text="binaryText(useSuez)"
        />
        <ThemedColumnText
          top-text="Panama"
          :bottom-text="binaryText(usePanama)"
        />

        <ThemedColumnText
          top-text="Kiel"
          :bottom-text="binaryText(useKiel)"
        />
        <ThemedColumnText
          top-text="Selected No-Go Areas"
          :bottom-text="noGoAreasText(selectedNoGoAreas)"
        />
        <ThemedColumnText
          top-text="Taiwan Strait"
          :bottom-text="binaryText(useTaiwanStrait)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EditExtraVoyageSettings from "./EditExtraVoyageSettings.vue";
import ThemedColumnText from "@/core/ThemedColumnText.vue";
import InfoIcon from "@/core/InfoIcon.vue";

import { mapState } from "vuex";
export default {
  name: "ExtraVoyageSettings",
  components: { EditExtraVoyageSettings,ThemedColumnText, InfoIcon },
  computed: {
    ...mapState("main", ["infoDetails"]),
    ...mapState("weatherRouting/formModule", [
      "landProximity",
      "tss",
      "eca",
      "avoidPiracy",
      "avoidTropicalStorms",
      "useSuez",
      "useKiel",
      "usePanama",
      "selectedNoGoAreas",
      "useTaiwanStrait",
    ]),
    landProximityText() {
      return `${this.landProximity} nmi`;
    },
  },
  methods: {
    binaryText(value) {
      return value ? "Yes" : "No";
    },
    noGoAreasText(areas) {
      if (areas === undefined) {
        return "-";
      }
      const totalAreas = areas.length;

      return totalAreas !== 0 ? `${totalAreas} areas` : "-";
    },
  },

};
</script>

<style scoped>
.navigation-section {
  background-color: var(--color-bg);
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
  padding: 10px;
}
.title {
  color: var(--color-text);
}
.title-container {
  display: flex;
  align-items: center;
}
.content-container {
  background-color: var(--color-bg);
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.column-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
